import React, { useState, useEffect } from "react";
import deviceone from "../../../assets/images/r1.png";
import devicetwo from "../../../assets/images/r2.png";
import devicethree from "../../../assets/images/r3.png";
import devicefour from "../../../assets/images/r4.png";
import allApi from "../../../api/allApi";
import errorIcon from "../../../assets/images/error-2.png";
import ap from "../../../assets/images/ap-2.png";
import switchImg from "../../../assets/images/switch.png";
import { all } from "axios";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Loader from "../common/Loader";
import { useLocalization } from "../localization/LocalizationContext";
import NmsTableSearch, { searchRows } from "../common/NmsTableSearch";

function HTTPS() {
  const { localizationStrings } = useLocalization();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModel, setEditModel] = useState(false);
  const [models, setModels] = useState([]);
  const [vendorName, setVendorName] = useState("");
  const [deviceType, setDeviceType] = useState("");
  const [deviceMonitoringInterval, setDeviceMonitoringInterval] = useState("");
  const [deviceHealthInterval, setDeviceHealthInterval] = useState("");
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [modelsPerPage] = useState(10);
  const [deleteModel, setDeleteModel] = useState(false);
  const [modeName, setModeName] = useState([]);
  const [devType, setDevType] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [editData, setEditData] = useState({
    vendorName: "",
    modelName: "",
    deviceType: "",
    deviceMonitoringInterval: "",
    deviceHealthInterval: "",
    icon_image: null,
    icon_name: "",
  });

  const [icon_name, seticon_name] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showUpdateSuccessModal, setShowUpdateSuccessModal] = useState(false);
  const [showDeleteSuccessModal, setShowDeleteSuccessModal] = useState(false);
  const isDisabled = true;
  const [showModelExistPopup, setShowModelExistPopup] = useState(false);

  const [formData, setFormData] = useState({
    vendorName: "",
    modelName: "",
    deviceType: "",
    deviceMonitoringInterval: "",
    deviceHealthInterval: "",
    icon_image: null,
    icon_name: "",
    modelFamily: "",
    image: null,
  });
  const [fileErrors, setFileErrors] = useState({
    deviceImage: "",
    vendorImage: "",
  });
  const [modelName, setModelName] = useState("");
  const handleAddModelClick = () => {
    setIsModalOpen(true);
  };
  const [searchValues, setSearchValues] = useState({
    modelName: "",
    deviceType: "",
    communicationProtocol: "",
    monitoringInterval: "",
    healthInterval: "",
    capabilities: "",
  });
  const [tableQuery, setTableQuery] = useState("");

  const [sortOrder, setSortOrder] = useState({
    modelName: "asc",
    deviceType: "asc",
    communicationProtocol: "asc",
    monitoringInterval: "asc",
    healthInterval: "asc",
    capabilities: "asc",
  });
  const [activeSortField, setActiveSortField] = useState("");

  useEffect(() => {
    fetchModels();
  }, []);

  useEffect(() => {
    if (editData && editModel) {
      setFormData({
        vendorName: editData.vendorName || "NETGEAR",
        modelName: editData.modelName || "",
        deviceType: editData.deviceType || "",
        deviceMonitoringInterval: editData.deviceMonitoringInterval || "",
        deviceHealthInterval: editData.deviceHealthInterval || "",
        icon_name: editData.icon_name || null,
        icon_image: editData.icon_image || null,
        image: editData.image_path || "",
      });
    }
  }, [editData, editModel]);

  const fetchModels = async () => {
    setLoading(true);
    setRefreshing(true);
    try {
      const api = new allApi();
      const response = await api.getRequest("api/model/allModels");

      const processedResponse = response.map((model) => {
        if (model.icon_image) {
          return {
            ...model,
            icon_image: `data:image/png;base64,${model.icon_image}`,
          };
        }
        return model;
      });

      setModels(processedResponse);
      setLoading(false);
      setRefreshing(false);
    } catch (error) {
      console.error("Error fetching models", error);
    }
  };
  const openDeleteModel = (models) => {
    setDeleteModel(true);
    setModeName(models.modelName);
    setDevType(models.deviceType);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleInputText = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateImage = (file) => {
    const validTypes = ["image/png", "image/jpeg", "image/svg+xml"];
    const maxSize = 1 * 1024 * 1024;

    if (!validTypes.includes(file.type)) {
      return "Choose Correct File Path";
    }

    if (file.size > maxSize) {
      return "The file should be less than 1 MB";
    }

    return "";
  };

  const getImageDimensions = (file) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
    });
  };

  // const handleFileChange = async (e, field) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     // const error = validateImage(file);
  //     // if (error) {
  //     //   setFileErrors((prevErrors) => ({ ...prevErrors, [field]: error }));
  //     //   return;
  //     // }

  //     const { width, height } = await getImageDimensions(file);
  //     // if ((width !== 16 || height !== 16) && (width > 32 || height > 32)) {
  //     //   setFileErrors((prevErrors) => ({
  //     //     ...prevErrors,
  //     //     [field]: "Image dimensions should be either 16x16 or up to 32x32.",
  //     //   }));
  //     //   return;
  //     // }

  //     setFileErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  //     setFormData((prevData) => ({ ...prevData, [field]: file }));
  //   }
  // };

  const getModelOptions = () => {
    switch (formData.deviceType) {
      case "AP":
        return [
          { value: "WAX650", label: "WAX650" },
          { value: "WAX650E", label: "WAX650E" },
        ];
      case "SW":
        return [
          { value: "GXCP", label: "GXCP" },
          { value: "GC320E", label: "GC320E" },
        ];
      case "ROUTER":
        return [
          { value: "BR500", label: "BR500" },
          { value: "PR60", label: "PR60" },
        ];
      default:
        return [];
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validFormats = ["image/jpeg", "image/jpg", "image/png"];
      const maxSize = 2 * 1024 * 1024; // 2 MB

      // Check file type
      if (!validFormats.includes(file.type)) {
        setFileErrors((prevErrors) => ({
          ...prevErrors,
          deviceImage: "Only JPG, JPEG, and PNG formats are allowed.",
        }));
        return;
      }

      // Check file size
      if (file.size > maxSize) {
        setFileErrors((prevErrors) => ({
          ...prevErrors,
          deviceImage: "File size should be less than 2 MB.",
        }));
        return;
      }

      // Check resolution
      const img = new Image();
      img.onload = () => {
        if (img.width > 1200 || img.height > 1200) {
          setFileErrors((prevErrors) => ({
            ...prevErrors,
            deviceImage: "Resolution should not exceed 1200 x 1200.",
          }));
        } else {
          setFormData((prevData) => ({
            ...prevData,
            icon_image: file,
            icon_name: file.name,
          }));
          setFileErrors((prevErrors) => ({
            ...prevErrors,
            deviceImage: "",
          }));
        }
      };
      img.src = URL.createObjectURL(file);
    }
  };

  const validateFields = (deviceMonitoringInterval, deviceHealthInterval) => {
    const regex = /^[0-9]*$/;
    return (
      regex.test(deviceMonitoringInterval) && regex.test(deviceHealthInterval)
    );
  };

  const handleAddModal = async () => {
    try {
      if (
        !validateFields(
          formData.deviceMonitoringInterval,
          formData.deviceHealthInterval
        )
      ) {
        setErrorMessage("Monitoring input fields only allows integer values");
        return;
      } else {
        setErrorMessage("");
      }

      const api = new allApi();
      const data = new FormData();

      data.append("modelName", formData.modelName);
      data.append("deviceType", formData.deviceType);
      data.append(
        "deviceMonitoringInterval",
        formData.deviceMonitoringInterval
      );
      data.append("deviceHealthInterval", formData.deviceHealthInterval);

      if (formData.icon_image) {
        data.append("icon_image", formData.icon_image);
        data.append("icon_name", formData.icon_name);
      }
      if (formData.deviceType == "AP") {
        data.append("modelFamily", formData.modelFamily);
      }

      console.log("Payload before sending:", {
        modelName: formData.modelName,
        deviceType: formData.deviceType,
        deviceMonitoringInterval: formData.deviceMonitoringInterval,
        deviceHealthInterval: formData.deviceHealthInterval,
        icon_image: formData.icon_image ? "Image selected" : "No image",
      });

      const response = await api.postMultiRequest(
        "api/model/addHttpModel",
        data
      );
      if (response) {
        setModels((prevModels) => [...prevModels, response]);
        setIsModalOpen(false);
        setShowSuccessModal(true);
        setFormData({
          vendorName: "",
          modelName: "",
          deviceType: "",
          deviceMonitoringInterval: "",
          deviceHealthInterval: "",
          icon_image: null,
          icon_name: "",
          errorMessage: "",
        });
      }
    } catch (error) {
      if (error.response.data.message === "The model name already exist") {
        setShowModelExistPopup(true);
        setIsModalOpen(false);
        setFormData({
          vendorName: "",
          modelName: "",
          deviceType: "",
          deviceMonitoringInterval: "",
          deviceHealthInterval: "",
          icon_image: null,
          icon_name: "",
          errorMessage: "",
        });
      } else {
        console.error("Error adding model", error);
      }
    }
  };
  const handleDeleteModel = async (modelName, deviceType) => {
    try {
      const api = new allApi();
      const payload = { modelName, deviceType };
      await api.deleteRequest("api/model/deleteHttpModel", payload);

      // Update the models list after deletion
      setModels((prevModels) =>
        prevModels.filter((model) => model.modelName !== modelName)
      );
      setDeleteModel(false);
      setShowDeleteSuccessModal(true);
      //alert(`${modelName} is deleted successfully.`);
    } catch (error) {
      console.error("Error deleting model", error);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setErrorMessage("");
    setFormData({
      vendorName: "",
      modelName: "",
      deviceType: "",
      deviceMonitoringInterval: "",
      deviceHealthInterval: "",
      icon_image: null,
      icon_name: "",
      modelFamily: "",
      image: null,
    });
    // fetchModels();
  };

  const handleEditData = async (deviceType, modelName) => {
    try {
      console.log("Fetching data for:", { deviceType, modelName });
      const api = new allApi();
      const response = await api.getRequest(
        `api/model/getHttpModel?deviceType=${deviceType}&modelName=${modelName}`
      );
      console.log("API Response: ", response);
      if (response) {
        setEditData(response); // Ensures editData is populated
        setFormData(response); // Sets formData for the current form
        setEditModel(true);
      } else {
        console.log("No data returned from API.");
      }
    } catch (error) {
      console.error("Failed to fetch data", error);
    }
  };

  const handleClose = () => {
    setEditModel(false);
    setErrorMessage("");
  };

  const updateModel = async () => {
    try {
      if (
        !validateFields(
          formData.deviceMonitoringInterval,
          formData.deviceHealthInterval
        )
      ) {
        setErrorMessage("Monitoring input fields only allows integer values");
        return;
      } else {
        setErrorMessage("");
      }
      const api = new allApi();
      const data = new FormData();

      // Use a fallback if editData is undefined
      const previousData = editData || {};

      // Always append basic form data
      data.append("modelName", formData.modelName);
      data.append("deviceType", formData.deviceType === "Switch" ? "SW" : "AP");
      data.append(
        "deviceMonitoringInterval",
        formData.deviceMonitoringInterval
      );
      data.append("deviceHealthInterval", formData.deviceHealthInterval);

      // Append icon_image and icon_name only if they are changed
      if (
        formData.icon_image &&
        (!previousData.icon_image ||
          formData.icon_image !== previousData.icon_image)
      ) {
        data.append("icon_image", formData.icon_image);
      }
      if (
        formData.icon_name &&
        (!previousData.icon_name ||
          formData.icon_name !== previousData.icon_name)
      ) {
        data.append("icon_name", formData.icon_name);
      }

      console.log("Payload :", {
        modelName: formData.modelName,
        deviceType: formData.deviceType,
        deviceMonitoringInterval: formData.deviceMonitoringInterval,
        deviceHealthInterval: formData.deviceHealthInterval,
        icon_image:
          formData.icon_image && formData.icon_image !== previousData.icon_image
            ? "Image selected"
            : "No image or unchanged",
        icon_name:
          formData.icon_name && formData.icon_name !== previousData.icon_name
            ? formData.icon_name
            : "Unchanged",
      });

      // Send the API request
      const response = await api.putMultiRequest(
        `api/model/updateHttpModel`,
        data
      );
      if (response) {
        setFormData(response);
        setErrorMessage("");
        handleClose();
        setShowUpdateSuccessModal(true);
      }
    } catch (error) {
      console.error("Failed to update Model", error);
    }
  };

  const filteredModels = searchRows(models, tableQuery, [
    "modelName",
    "deviceType",
    "deviceCommunicationProtocol",
    "deviceMonitoringInterval",
    "deviceHealthInterval",
    "capabilities",
  ]);

  const sortedModels = [...filteredModels].sort((a, b) => {
    if (!activeSortField) return 0;

    let aValue, bValue;

    switch (activeSortField) {
      case "modelName":
        aValue = a.modelName;
        bValue = b.modelName;
        break;
      case "deviceType":
        aValue = a.deviceType;
        bValue = b.deviceType;
        break;
      case "communicationProtocol":
        aValue = a.deviceCommunicationProtocol;
        bValue = b.deviceCommunicationProtocol;
        break;
      case "monitoringInterval":
        aValue = getIntervalInSeconds(a.deviceMonitoringInterval);
        bValue = getIntervalInSeconds(b.deviceMonitoringInterval);
        break;
      case "healthInterval":
        aValue = getIntervalInSeconds(a.deviceHealthInterval);
        bValue = getIntervalInSeconds(b.deviceHealthInterval);
        break;
      case "capabilities":
        aValue = a.capabilities;
        bValue = b.capabilities;
        break;
      default:
        return 0;
    }

    if (aValue < bValue) return sortOrder[activeSortField] === "asc" ? -1 : 1;
    if (aValue > bValue) return sortOrder[activeSortField] === "asc" ? 1 : -1;

    return 0;
  });

 function parseIntervalToSeconds(value) {
    if (value === undefined || value === null || value === "") return null;
    if (typeof value === "number") return value;
    const str = String(value).trim().toLowerCase();

    // plain numeric string
    if (/^[\d.]+$/.test(str)) return parseFloat(str);

    // patterns like "2 minutes", "120s", "2 min", "2 m", "1 hour"
    const minuteMatch = str.match(/([\d.]+)\s*(min|minute|minutes|m)\b/);
    if (minuteMatch) return parseFloat(minuteMatch[1]) * 60;

    const hourMatch = str.match(/([\d.]+)\s*(h|hr|hour|hours)\b/);
    if (hourMatch) return parseFloat(hourMatch[1]) * 3600;

    const secMatch = str.match(/([\d.]+)\s*(s|sec|second|seconds)\b/);
    if (secMatch) return parseFloat(secMatch[1]);

    // fallback: extract first number if present
    const digitsMatch = str.match(/([\d.]+)/);
    if (digitsMatch) return parseFloat(digitsMatch[1]);

    return null;
  }

  function getIntervalInSeconds(value) {
    const secs = parseIntervalToSeconds(value);
    return Number.isFinite(secs) ? secs : 0;
  }

  // unified formatter: accepts raw value (string or number) and returns display text
  function formatInterval(value) {
    const seconds = parseIntervalToSeconds(value);
    if (seconds === undefined || seconds === null || isNaN(seconds)) return "N/A";
    if (seconds % 60 === 0 && seconds >= 60) {
      return `${seconds / 60} minutes`;
    }
    return `${seconds} seconds`;
  }

  // Add this helper function above your return
  function formatInterval(seconds) {
    if (seconds === undefined || seconds === null || seconds === "")
      return "N/A";
    const sec = Number(seconds);
    if (isNaN(sec)) return "N/A";
    if (sec % 60 === 0 && sec >= 60) {
      return `${sec / 60} minutes`;
    }
    return `${sec} seconds`;
  }

  const indexOfLastModel = currentPage * modelsPerPage;
  const indexOfFirstModel = indexOfLastModel - modelsPerPage;

  const totalFilteredModel = sortedModels.length;

  const currentModels = sortedModels.slice(indexOfFirstModel, indexOfLastModel);
  // const totalFilteredModel = models.length;
  // const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

  const totalPages = Math.ceil(totalFilteredModel / modelsPerPage);
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handleFirstPage = () => {
    setCurrentPage(1);
  };
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const range = 1;
    const start = Math.max(1, currentPage - range);
    const end = Math.min(totalPages, currentPage + range);

    return [...Array(end - start + 1).keys()].map((i) => start + i);
  };

  const disableButton = !(
    formData.deviceMonitoringInterval &&
    formData.deviceHealthInterval &&
    formData.vendorName &&
    formData.deviceType &&
    formData.modelName &&
    formData.icon_image &&
    !fileErrors.deviceImage
  );

  const handleSearchChange = (e, field) => {
    const value = e.target.value;

    setSearchValues((prev) => ({
      ...prev,
      [field]: value,
    }));

    setCurrentPage(1); // 🔥 important
  };

  const handleSortChange = (field) => {
    setActiveSortField(field);
    setSortOrder((prev) => ({
      ...prev,
      [field]: prev[field] === "asc" ? "desc" : "asc",
    }));
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="inc-card ch-100">
          <div className="inc-card-title">
            <h3>{localizationStrings?.httpsManagement}</h3>
            <div className="inc-card-button">
              <NmsTableSearch
                value={tableQuery}
                onChange={(value) => {
                  setTableQuery(value);
                  setCurrentPage(1);
                }}
                placeholder={localizationStrings?.search || "Search models"}
              />
              <button
                className="text-btn primary-btn"
                onClick={handleAddModelClick}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                {localizationStrings?.add}
              </button>

              <button
                className="icon-btn"
                title="Refresh"
                onClick={() => fetchModels()}
              >
                {refreshing ? (
                  <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                ) : (
                  <i className="fa fa-refresh" aria-hidden="true"></i>
                )}
              </button>
              {/* <button className="icon-btn" title="Delete">
                <i className="fa fa-trash" aria-hidden="true"></i>
              </button> */}
            </div>
          </div>
          <div className="inc-card-body">
            {loading ? (
              <Loader />
            ) : (
              <div className="inc-card-table">
                <table className="full-table m-head device-pic">
                  <thead>
                    <tr>
                      {/* <th>
                        <label className="checkbox">
                          <input type="checkbox" />
                          <span className="indicator"></span>
                        </label>
                      </th> */}
                      <th>{localizationStrings?.modelImage}</th>
                      <th
                        className={`inc-th-sort${
                          activeSortField === "modelName" ? " is-active" : ""
                        }`}
                        onClick={() => handleSortChange("modelName")}
                      >
                        {localizationStrings?.modelName}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className={`inc-th-sort${
                          activeSortField === "deviceType" ? " is-active" : ""
                        }`}
                        onClick={() => handleSortChange("deviceType")}
                      >
                        {localizationStrings?.deviceType}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className={`inc-th-sort${
                          activeSortField === "communicationProtocol"
                            ? " is-active"
                            : ""
                        }`}
                        onClick={() => handleSortChange("communicationProtocol")}
                      >
                        {localizationStrings?.communicationProtocol}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className={`inc-th-sort${
                          activeSortField === "monitoringInterval"
                            ? " is-active"
                            : ""
                        }`}
                        onClick={() => handleSortChange("monitoringInterval")}
                      >
                        {localizationStrings?.monitoringInterval}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className={`inc-th-sort${
                          activeSortField === "healthInterval" ? " is-active" : ""
                        }`}
                        onClick={() => handleSortChange("healthInterval")}
                      >
                        {localizationStrings?.healthInterval}l
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className={`inc-th-sort${
                          activeSortField === "capabilities" ? " is-active" : ""
                        }`}
                        onClick={() => handleSortChange("capabilities")}
                      >
                        {localizationStrings?.capabilities}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th>{localizationStrings?.action}</th>
                    </tr>
                    <tr className="search-border">
                      <td></td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          value={searchValues.modelName}
                          onChange={(e) => handleSearchChange(e, "modelName")}
                        />
                        <i
                          className={`fa ${
                            sortOrder.modelName === "asc"
                              ? "fa fa-sort-amount-desc"
                              : "fa fa-sort-amount-asc"
                          }`}
                          onClick={() => handleSortChange("modelName")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          value={searchValues.deviceType}
                          onChange={(e) => handleSearchChange(e, "deviceType")}
                        />
                        <i
                          className={`fa ${
                            sortOrder.deviceType === "asc"
                              ? "fa fa-sort-amount-desc"
                              : "fa fa-sort-amount-asc"
                          }`}
                          onClick={() => handleSortChange("deviceType")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          value={searchValues.communicationProtocol}
                          onChange={(e) =>
                            handleSearchChange(e, "communicationProtocol")
                          }
                        />
                        <i
                          className={`fa ${
                            sortOrder.communicationProtocol === "asc"
                              ? "fa fa-sort-amount-desc"
                              : "fa fa-sort-amount-asc"
                          }`}
                          onClick={() =>
                            handleSortChange("communicationProtocol")
                          }
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          value={searchValues.monitoringInterval}
                          onChange={(e) =>
                            handleSearchChange(e, "monitoringInterval")
                          }
                        />
                        <i
                          className={`fa ${
                            sortOrder.monitoringInterval === "asc"
                              ? "fa fa-sort-amount-desc"
                              : "fa fa-sort-amount-asc"
                          }`}
                          onClick={() => handleSortChange("monitoringInterval")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          value={searchValues.healthInterval}
                          onChange={(e) =>
                            handleSearchChange(e, "healthInterval")
                          }
                        />
                        <i
                          className={`fa ${
                            sortOrder.healthInterval === "asc"
                              ? "fa fa-sort-amount-desc"
                              : "fa fa-sort-amount-asc"
                          }`}
                          onClick={() => handleSortChange("healthInterval")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          value={searchValues.capabilities}
                          onChange={(e) =>
                            handleSearchChange(e, "capabilities")
                          }
                        />
                        <i
                          className={`fa ${
                            sortOrder.capabilities === "asc"
                              ? "fa fa-sort-amount-desc"
                              : "fa fa-sort-amount-asc"
                          }`}
                          onClick={() => handleSortChange("capabilities")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td colSpan="7"></td>
                    </tr>
                  </thead>
                  <tbody>
                    {currentModels.map((model) => (
                      <tr key={model.id}>
                        {/* <td>
                          <label className="checkbox">
                            <input type="checkbox" />
                            <span className="indicator"></span>
                          </label>
                        </td> */}
                        <td>
                          <img src={model.icon_image} alt="Device" />
                        </td>
                        <td>{model.modelName || "N/A"}</td>
                        <td>{model.deviceType || "N/A"}</td>
                        <td>{model.deviceCommunicationProtocol || "N/A"}</td>
                        <td>{model.deviceMonitoringInterval != null ? model.deviceMonitoringInterval : "N/A"}</td>
<td>{model.deviceHealthInterval != null ? model.deviceHealthInterval : "N/A"}</td>
                        <td>{model.capabilities || "N/A"}</td>
                        <td>
                          <div className="button-group">
                            <button
                              title="Delete"
                              // data-bs-toggle="modal"
                              // data-bs-target="#deleteModel"
                              onClick={() => openDeleteModel(model)}
                            >
                              <i className="fa fa-trash" aria-hidden="true"></i>
                            </button>
                            <button title="Edit">
                              <i
                                className="fa fa-pencil"
                                aria-hidden="true"
                                onClick={() => {
                                  handleEditData(
                                    model.deviceType,
                                    model.modelName
                                  );
                                }}
                              ></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {isModalOpen && (
            <div className="customModal">
              <div className="c-modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {localizationStrings?.addModel}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleCancel}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="add-ssid-body">
                      <form>
                        <div className="row d-flex">
                          <div className="col-lg-6">
                            <label
                              htmlFor="vendorName"
                              className="col-form-label"
                            >
                              {localizationStrings?.vendorName}{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              name="vendorName"
                              value={formData.vendorName}
                              onChange={handleInputChange}
                            >
                              <option value="">
                                {localizationStrings?.selectVendor}
                              </option>
                              <option value="NETGEAR">NETGEAR</option>
                              <option value="CISCO">CISCO</option>
                            </select>
                          </div>
                          <div className="col-lg-6">
                            <label
                              htmlFor="deviceType"
                              className="col-form-label"
                            >
                              {localizationStrings?.deviceType}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              name="deviceType"
                              value={formData.deviceType}
                              onChange={handleInputChange}
                            >
                              <option value="">
                                {localizationStrings?.selectDeviceType}
                              </option>
                              <option value="AP">AP</option>
                              <option value="SW">Switch</option>
                              <option value="ROUTER">Router</option>
                            </select>
                          </div>
                          {formData.deviceType == "AP" && (
                            <div className="col-lg-6">
                              <label
                                htmlFor="modelName"
                                className="col-form-label"
                              >
                                {localizationStrings?.modelFamily}{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                className="form-select"
                                name="modelFamily"
                                value={formData.modelFamily}
                                onChange={handleInputChange}
                              >
                                <option value="">
                                  {localizationStrings?.selectModel}
                                </option>
                                {getModelOptions().map((model) => (
                                  <option key={model.value} value={model.value}>
                                    {model.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                          <div className="col-lg-6">
                            <label
                              htmlFor="modelName"
                              className="col-form-label"
                            >
                              {localizationStrings?.modelName}{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              name="modelName"
                              value={formData.modelName}
                              onChange={handleInputChange}
                            >
                              <option value="">
                                {localizationStrings?.selectModel}
                              </option>
                              {getModelOptions().map((model) => (
                                <option key={model.value} value={model.value}>
                                  {model.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-lg-6">
                            <label
                              htmlFor="deviceMonitoringInterval"
                              className="col-form-label"
                            >
                              {localizationStrings?.deviceMonitoringInterval} (
                              {localizationStrings?.inSeconds}){" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              // id="deviceMonitoringInterval"
                              name="deviceMonitoringInterval"
                              value={formData.deviceMonitoringInterval}
                              onChange={handleInputChange}
                            />
                          </div>
                          <div className="col-lg-6">
                            <label
                              htmlFor="deviceHealthInterval"
                              className="col-form-label"
                            >
                              {localizationStrings?.deviceHealthInterval} (
                              {localizationStrings?.inSeconds}){" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              // id="deviceHealthInterval"
                              name="deviceHealthInterval"
                              value={formData.deviceHealthInterval}
                              onChange={handleInputChange}
                            />
                          </div>
                          <div className="col-lg-6">
                            <label
                              htmlFor="DeviceImage"
                              className="col-form-label"
                            >
                              {localizationStrings?.deviceImage}{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="file"
                              className="form-control"
                              name="deviceImage"
                              onChange={handleImageChange}
                            />
                            {fileErrors.deviceImage && (
                              <div className="text-danger">
                                {fileErrors.deviceImage}
                              </div>
                            )}
                          </div>
                        </div>
                        {errorMessage && (
                          <div className="alert alert-danger" role="alert">
                            {errorMessage}
                          </div>
                        )}
                        <div className="border-line"></div>

                        <h4 className="mt-2">
                          {localizationStrings?.capabilities}
                        </h4>
                        <div className="row d-flex">
                          <div className="col-lg-6">
                            <label htmlFor="port" className="col-form-label">
                              {localizationStrings?.supportedPort}
                            </label>
                            <select
                              className="form-select"
                              name="port"
                              placeholder="port"
                            >
                              <option>8</option>
                              <option>12</option>
                              <option>16</option>
                              <option>32</option>
                            </select>
                          </div>
                          <div className="col-lg-6">
                            <label
                              htmlFor="ClientSupport"
                              className="col-form-label"
                            >
                              {localizationStrings?.maxClientSupport}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="ClientSupport"
                              placeholder={localizationStrings?.clientSupport}
                            />
                          </div>
                          <div className="col-lg-6">
                            <label>&nbsp;</label>
                            <div className="switch-box">
                              <strong>
                                {localizationStrings?.radioEnabled}
                              </strong>
                              <label className="ice-switch">
                                <input type="checkbox" name="Radio" />
                                <span className="slider"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline"
                      onClick={handleCancel}
                    >
                      {localizationStrings?.cancel}
                    </button>
                    <button
                      type="button"
                      className="text-btn primary-btn"
                      disabled={disableButton}
                      onClick={handleAddModal}
                    >
                      {localizationStrings?.save}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {editModel && (
            <div className="customModal">
              <div className="c-modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {localizationStrings?.editModel}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleClose}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="add-ssid-body">
                      <form>
                        <div className="row d-flex">
                          <div className="col-lg-6">
                            <label
                              htmlFor="vendorName"
                              className="col-form-label"
                            >
                              {localizationStrings?.vendorName}
                            </label>
                            <input
                              type="text"
                              disabled={isDisabled}
                              style={{
                                cursor: isDisabled ? "not-allowed" : "default",
                              }}
                              className="form-control"
                              id="vendorName"
                              name="vendorName"
                              value={formData.vendorName || "NETGEAR"}
                              readOnly
                            />
                          </div>
                          <div className="col-lg-6">
                            <label
                              htmlFor="deviceType"
                              className="col-form-label"
                            >
                              {localizationStrings?.deviceType}
                            </label>
                            <input
                              type="text"
                              disabled={isDisabled}
                              style={{
                                cursor: isDisabled ? "not-allowed" : "default",
                              }}
                              className="form-control"
                              id="deviceType"
                              name="deviceType"
                              value={formData.deviceType || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-lg-6">
                            <label
                              htmlFor="modelName"
                              className="col-form-label"
                            >
                              {localizationStrings?.modelName}
                            </label>
                            <input
                              type="text"
                              disabled={isDisabled}
                              style={{
                                cursor: isDisabled ? "not-allowed" : "default",
                              }}
                              className="form-control"
                              id="modelName"
                              name="modelName"
                              value={formData.modelName || ""}
                              readOnly
                            />
                          </div>
                          <div className="col-lg-6">
                            <label
                              htmlFor="deviceMonitoringInterval"
                              className="col-form-label"
                            >
                              {localizationStrings?.deviceMonitoringInterval} (
                              {localizationStrings?.inSeconds})
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="deviceMonitoringInterval"
                              name="deviceMonitoringInterval"
                              value={formData.deviceMonitoringInterval || ""}
                              onChange={handleInputText}
                            />
                          </div>
                        </div>
                        <div className="row d-flex">
                          <div className="col-lg-6">
                            <label
                              htmlFor="deviceHealthInterval"
                              className="col-form-label"
                            >
                              {localizationStrings?.deviceHealthInterval} (
                              {localizationStrings?.inSeconds})
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="deviceHealthInterval"
                              name="deviceHealthInterval"
                              value={formData.deviceHealthInterval || ""}
                              onChange={handleInputText}
                            />
                          </div>
                          <div className="col-lg-6">
                            <label
                              htmlFor="DeviceImage"
                              className="col-form-label"
                            >
                              {localizationStrings?.deviceImage}
                            </label>
                            <div>{formData.icon_name || "No icon name"}</div>
                            {/* {formData.icon_image && (
                              <div className="image-preview mb-2">
                                <img
                                  src={`data:image/png;base64,${formData.icon_image}`}
                                  alt={formData.icon_name || "Device Icon"}
                                  style={{ maxWidth: "100px", maxHeight: "100px" }}
                                />
                                <div>{formData.icon_name || "No icon name"}</div>
                              </div>
                            )} */}
                            <input
                              type="file"
                              className="form-control"
                              name="icon_image"
                              onChange={handleImageChange}
                            />
                            {fileErrors.deviceImage && (
                              <div className="text-danger">
                                {fileErrors.deviceImage}
                              </div>
                            )}
                          </div>
                          {errorMessage && (
                            <div className="alert alert-danger" role="alert">
                              {errorMessage}
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline"
                      onClick={handleClose}
                    >
                      {localizationStrings?.cancel}
                    </button>
                    <button
                      type="button"
                      className="text-btn primary-btn"
                      onClick={updateModel}
                    >
                      {localizationStrings?.save}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="pagination-container">
            {totalFilteredModel > 0 ? (
              <>
                <div className="pagination-info">
                  <p>
                    {localizationStrings?.showing} {indexOfFirstModel + 1}
                    {"-"}
                    {Math.min(
                      currentPage * modelsPerPage,
                      totalFilteredModel
                    )}{" "}
                    {localizationStrings?.of} {totalFilteredModel}{" "}
                    {localizationStrings?.records}
                  </p>
                </div>
                <div className="pagination">
                  <button
                    onClick={handleFirstPage}
                    disabled={currentPage === 1}
                  >
                    {localizationStrings?.firstPage}
                  </button>
                  <button onClick={handlePrevPage} disabled={currentPage === 1}>
                    {localizationStrings?.previous}
                  </button>
                  {getPageNumbers().map((page) => (
                    <button
                      key={page}
                      onClick={() => handlePageClick(page)}
                      className={currentPage === page ? "active" : ""}
                    >
                      {page}
                    </button>
                  ))}
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    {localizationStrings?.next}
                  </button>
                  <button
                    onClick={handleLastPage}
                    disabled={currentPage === totalPages}
                  >
                    {localizationStrings?.lastPage}
                  </button>
                </div>
              </>
            ) : (
              <div>
                <p>{localizationStrings?.noRecords}</p>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <div
        className={`modal fade`}
        id="deleteModel"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content inc-modal">
            <div className="modal-body success-msg">
              <img src={errorIcon} alt="error" />
              <p>Are you sure to delete {modeName} Model?</p>
              <button
                className="text-btn primary-btn"
                data-bs-dismiss="modal"
                onClick={() => handleDeleteModel(modeName,devType)}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div> */}
      {showModelExistPopup && (
        <div className="customModal confirm-modal">
          <div className="modal-dialog modal-dialog-centered small">
            <div className="modal-content inc-modal">
              <div className="modal-body">
                <img src={errorIcon} alt="error" />
                <h3>{localizationStrings?.modelExists}</h3>
                <div className="modal-footer">
                  <button
                    className="text-btn primary-btn"
                    onClick={() => setShowModelExistPopup(false)}
                  >
                    {localizationStrings?.close}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {deleteModel && (
        <div className="customModal confirm-modal">
          <div className="modal-dialog modal-dialog-centered small">
            <div className="modal-content inc-modal">
              <div className="modal-body">
                <img src={errorIcon} alt="error" />
                <h3>{localizationStrings?.deleteConfirmation}</h3>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline"
                    onClick={() => setDeleteModel(false)}
                  >
                    {localizationStrings?.no}
                  </button>
                  <button
                    className="text-btn primary-btn"
                    onClick={() => handleDeleteModel(modeName, devType)}
                  >
                    {localizationStrings?.yes}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert index-2000"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.modelAddedSuccessfully}</p>
        <Button
          onClick={() => {
            setShowSuccessModal(false);
            fetchModels();
          }}
        >
          {localizationStrings?.ok}
        </Button>
      </Modal>
      <Modal
        show={showDeleteSuccessModal}
        onHide={() => setShowDeleteSuccessModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert index-2000"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.modelDeletedSuccessfully}</p>
        <Button
          onClick={() => {
            setShowDeleteSuccessModal(false);
            fetchModels();
          }}
        >
          {localizationStrings?.ok}
        </Button>
      </Modal>
      <Modal
        show={showUpdateSuccessModal}
        onHide={() => setShowUpdateSuccessModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert index-2000"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.modelUpdatedSuccessfully}</p>
        <Button
          onClick={() => {
            setShowUpdateSuccessModal(false);
            fetchModels();
          }}
        >
          {localizationStrings?.ok}
        </Button>
      </Modal>
    </div>
  );
}

export default HTTPS;
